import React from "react";
import {Hero, PageContent} from "../../components";

function Awards() {
  return (
    <div className="flex overflow-x-hidden overflow-y-hidden relative flex-col -z-10">
      <Hero title={"Awards"}></Hero>

        <PageContent>
            {`

From November 2nd to 5th, 2023, the **Ionis-Paris** team attended the Grand 
Jamboree at Porte de Versailles in Paris. During this event, we explored the 
projects of other teams and exchanged experiences. We showcased our own 
**project at the Plaza** in our village, defending it by answering the **jury’s 
questions**, and also **hosting a booth** to introduce and share our work with 
others.

<div class="image_frame">
    <img class="illustration medium" src="https://static.igem.wiki/teams/4577/wiki/project/awards/grand-jamboree.jpeg">
</div>

We are happy to announce we have won: 

<div class="image_frame">
    <img class="illustration small" src="https://static.igem.wiki/teams/4577/wiki/project/awards/gold-medal.png">
    <p><b><h2>The Gold Medal !</h2></b></p>
</div>

        `}
        </PageContent>
    </div>
  );
}

export default Awards;
